import { Record } from "immutable";
import moment from "moment";
import orange from "material-ui/colors/orange";
import blue from "material-ui/colors/blue";
import teal from "material-ui/colors/teal";
import lime from "material-ui/colors/lime";
import indigo from "material-ui/colors/indigo";

const SurveyRecord = Record({
  id: null,
  customerId: null,
  employees: 0,
  additionLimit: 0,
  startDt: "20180701",
  endDt: "20180801",
  status: 0,
  freeCommentCheck2: false,
  interimYmd: "",
  requiredAnswerFlg: false,
  surveyPassword: "",
  surveyUrl: "",
  lockVersion: 0,
  resultCount: 0,
  additionCount: 0,
  surveyName: "",
  canViewReport: false,
  checkFlg: null,
  // 関連
  surveyLocales: [],
  progress: 0,
  editQuestionsFlg: 0,
  editAdditionsFlg: 0,
  isMailSendToEmployee:false
});

const TERM_FORMAT = "YYYY年MM月DD日 HH:mm";

export const STATUS = {
  READY: 1,
  CONFIRM: 2,
  OPEN: 3,
  STOP: 4,
  FINISH: 5
};

export const allOptions = [
  { value: "-", label: "-", number: 7 },
  { value: "broadcast", label: "発行/一斉送信\n", number: 8 },
  { value: "reminder", label: "リマインド送信", number: 9 },
];

class Survey extends SurveyRecord {
  isNew() {
    return this.id === null;
  }

  isOpen() {
    return this.status === STATUS.OPEN;
  }
  isReady() {
    return this.status === STATUS.READY;
  }
  isConfirm() {
    return this.status === STATUS.CONFIRM;
  }
  isOpened() {
    return this.status >= STATUS.OPEN;
  }
  isFinish() {
    return this.status === STATUS.FINISH;
  }
  hasAddition() {
    return this.additionLimit > 0;
  }

  termFmt() {
    const startDt = moment(this.startDt).format(TERM_FORMAT);
    const endDt = moment(this.endDt).format(TERM_FORMAT);
    return `${startDt} ~ ${endDt}`;
  }

  startDtFmt(formatStr) {
    return moment(this.startDt).format(formatStr || TERM_FORMAT);
  }

  endDtFmt(formatStr) {
    return moment(this.endDt).format(formatStr || TERM_FORMAT);
  }

  tickProgress() {
    return Number(this.progressRatio() / 5);
  }

  canUseBaseInfo(isAdmin) {
    if (isAdmin) {
      return [STATUS.FINISH].indexOf(this.status) === -1;
    }
    return [STATUS.READY].indexOf(this.status) > -1;
  }

  canUseAttr(isAdmin) {
    if (isAdmin) {
      return [STATUS.READY, STATUS.CONFIRM].indexOf(this.status) > -1;
    }
    return [STATUS.READY].indexOf(this.status) > -1;
  }

  canUseBase(isAdmin) {
    return isAdmin && [STATUS.READY, STATUS.CONFIRM].indexOf(this.status) > -1;
  }

  canUseAdditions(isAdmin) {
    if (isAdmin) {
      return [STATUS.READY, STATUS.CONFIRM].indexOf(this.status) > -1;
    }
    return [STATUS.READY].indexOf(this.status) > -1;
  }

  canUseMonitor() {
    return [STATUS.OPEN, STATUS.STOP, STATUS.FINISH].indexOf(this.status) > -1;
  }

  // 引数がある場合はそれを表示、なければ現在のステータスを表示
  statusFmt(status = this.status) {
    switch (status) {
      case STATUS.READY:
        return "準備中";
      case STATUS.CONFIRM:
        return "確定";
      case STATUS.OPEN:
        // 開始日前は"公開（予約）"、開始日を過ぎたら "公開"を表示
        return moment() < moment(this.startDt) ? "公開(予約)" : "公開";
      case STATUS.STOP:
        return "中断";
      case STATUS.FINISH:
        return "終了";
      case 0:
        return "";
      default:
        throw new Error("unexpected args");
    }
  }

  statusColor() {
    switch (this.status) {
      case STATUS.READY:
        return lime[700];
      case STATUS.CONFIRM:
        return blue[400];
      case STATUS.OPEN:
        return teal[500];
      case STATUS.STOP:
        return orange[700];
      case STATUS.FINISH:
        return indigo[900];
      case 0:
        return null;
      default:
        throw new Error("unexpected args");
    }
  }

  backgroundColor() {
    return { backgroundColor: this.statusColor() };
  }

  progressRatio() {
    if (!this.employees) {
      return 0;
    }
    const all = this.employees;
    const done = this.resultCount;
    const ratio = Number(done) / Number(all);

    return Math.min(Math.round(ratio * 100), 100);
  }

  progressFmt() {
    const all = this.employees;
    const done = this.resultCount;
    return `(${done}/${all})`;
  }

  answerLoginUrl() {
    return this.surveyUrl
      ? `${window.location.origin}/answer/login/survey/${this.surveyUrl}`
      : "";
  }

  answerPreviewUrl() {
    return `${window.location.origin}/preview/start/${this.id}`;
  }
  static mailSendTypeOptions(urlNullCount) {
    if (urlNullCount !== 0) {
      return allOptions.filter(option => option.value !== "reminder");
    }
    return allOptions;
  }

  static getMailSendTypeByValue(value) {
    return allOptions.filter(o => o.value !== "-").find(o => o.value === value);
  }
}

export default Survey;



// WEBPACK FOOTER //
// ./src/models/Survey.js